import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';

type CellParams = ICellRendererParams;

@Component({
  selector: 'app-pan-sold-details-action-type',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-sold-details-action-type.component.html',
  styleUrl: './cell-sold-details-action-type.component.scss',
})
export class CellSoldDetailsActionTypeComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
